// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"179":"ad6a0892","694":"6974d99a","798":"749b3d38","866":"d09b961a","895":"cc740561"}[chunkId] + ".css";
};